import React from "react";
import { Menu, MenuItem, IconButton, Tooltip,Button } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useTranslation } from "react-i18next";

interface CustomAction {
    label: string;
    onClick: () => void;
    color?: string; 
}
interface DefaultActionsProps {
    onSave?: () => void;
    onCopy?: () => void;
    onDelete?: () => void;
    onPost?:() => void;
    onCancel?: () => void;
    onImport?: () => void;
    onRedeem?: () => void;
    customActions?: CustomAction[];
}
const DefaultActions: React.FC<DefaultActionsProps> = ({
    onSave,
    onCopy,
    onDelete,
    onPost,
    onCancel,
    onImport,
    onRedeem,
    customActions
}) => {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const { t } = useTranslation();


    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <Tooltip title="Actions">
                <Button variant="contained" onClick={handleClick}
                    endIcon={<MoreVertIcon />}
                    size="small"
                >
                    {t("common.actions")}
                </Button>
   
            </Tooltip>
            <Menu anchorEl={anchorEl} open={open} onClose={handleClose} >
                {onSave && (<MenuItem onClick={() => { handleClose(); onSave(); }}> {t("common.save")}</MenuItem>) }
                {onCopy && (<MenuItem onClick={() => { handleClose(); onCopy(); }}> {t("common.copy")}</MenuItem>)}
                {onPost && (<MenuItem onClick={() => { handleClose(); onPost(); }}> {t("common.post")}</MenuItem>)}
                {onImport && (<MenuItem onClick={() => { handleClose(); onImport(); }}> {t("common.import")}</MenuItem>)}
                {onCancel && (<MenuItem onClick={() => { handleClose(); onCancel(); }} style={{ color: "red" }}> {t("common.cancel_mak")}</MenuItem>)}
                {onDelete && (<MenuItem onClick={() => { handleClose(); onDelete(); }} style={{ color: "red" }}> {t("common.delete")}</MenuItem>)}
                {onRedeem && (<MenuItem onClick={() => { handleClose(); onRedeem(); }} style={{ color: "red" }}> {t("common.redeem")}</MenuItem>)}
                {customActions?.map((action, idx) => (
                    <MenuItem
                        key={idx}
                        onClick={() => {
                            handleClose();
                            action.onClick();
                        }}
                        style={{ color: action.color ?? "inherit" }}
                    >
                        {action.label}
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
};
export default DefaultActions;